<template>
	<div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;">
		<div style="">
			<!--       -->
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable ref="ManufacturerRef" :loadingTable="loadingTableManufacturer" @onRowClick="onRowClick"
				colnum=7 :tableData="tableData" :headerData="headerData" height="100%"
				@handleSelectionChange="(e)=>selectIds = e">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total" :pageSize="pageSize"></Pagination>
			</div>
		</div>
		<DialogFrom width="520px" :title="DialogFrom.title" :dialogVisible="dialogVisibles" @cancel="cancel"
			@dialogOK="dialogOK">
			<div class="from" style="position: relative;overflow-y: scroll;min-height: 100px;">
				<template v-for="(item , index) of EditorFromData">
					<Commondropdownlist :key="index" ref="DialogFromref" :event="item.event" :disabledHB="item.disabled"
						:selcoms="item.selcoms" :widths="item.widths" :options="item.options" :btx="item.btx"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:disabled="item.disabled">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisiblesMessage" @cancel="cancelMessage"
			@dialogOK="dialogOKMessage" :src="Dialog.src">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">{{ Dialog.title }}</span>
		</Dialog>
	</div>
</template>

<script>
	import Commontable from '@/components/common-table.vue'
	import Commonbtn from '@/components/common-btn.vue'
	import Pagination from '@/components/pagination.vue'
	import DialogFrom from '@/components/dialog-from.vue'
	import Commondropdownlist from '@/components/common-dropdownlist.vue'
	import Dialog from '@/components/dialog.vue'
	import utils from '@/common/utils'
	import headerData from './headerData/headerData'
	import EditorFromData from './FromData/EditorFromData'
	import {
		GetGradeStateList,
		AddGradeState,
		GetGradeStateInfo,
		EditGradeState,
		DeleteGradeState,
	} from '@/api/newsapi'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			Commondropdownlist,
			DialogFrom,
			Dialog
		},
		props: {},
		data() {
			return {
				selectIds: [],
				loadingTableManufacturer: true,
				dialogVisibles: false,
				dialogVisiblesMessage: false,
				total: 0,
				pageIndex: 1,
				pageSize: 20,
				RowData: null,
				tableData: [],
				headerData: [],
				EditorFromData: [],
				DialogFrom: {
					title: '加载中...'
				},
				Dialog: {
					title: '加载中...',
					src: require('@/assets/icon/icon-errors.png')
				},
				from: {
					MFName: '',
					Abbr: ''
				},
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false,
					approval: false
				},
			}
		},
		created() {
			this.GetGradeStateList();
		},
		mounted() {
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.EditorFromData = JSON.parse(JSON.stringify(EditorFromData))
		},
		methods: {
			// 列表
			async GetGradeStateList() {
				let {
					data,
					message,
					code
				} = await GetGradeStateList({
					PageSize: this.pageSize,
					PageIndex: this.PageIndex
				})
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data
				} else {
					this.$message.warning(message)
				}
			},
			// 新增
			async AddGradeState() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message
				} = await AddGradeState({
					Grade: this.$refs.DialogFromref[0].modelvalue,
					GradeText: this.$refs.DialogFromref[1].modelvalue
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibles = false
					this.GetGradeStateList()
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 详情
			async GetGradeStateInfo() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await GetGradeStateInfo({
					AutoID: this.RowData.AutoID
				})
				if (code == 0) {
					this.dialogVisibles = true
					this.DialogFrom.title = '修改'
					setTimeout(() => {
						this.$refs.DialogFromref[0].modelvalue = data.Grade
						this.$refs.DialogFromref[1].modelvalue = data.GradeText
					}, 100)
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 修改
			async EditGradeState() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message
				} = await EditGradeState({
					AutoID: this.RowData.AutoID,
					Grade: this.$refs.DialogFromref[0].modelvalue,
					GradeText: this.$refs.DialogFromref[1].modelvalue
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibles = false
					this.GetGradeStateList()
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			//删除
			async DeleteGradeState() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message
				} = await DeleteGradeState({
					AutoIDs: this.selectIds.map(it => it.AutoID)
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisiblesMessage = false
					this.GetGradeStateList()
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			add() {
				this.DialogFrom.title = '新增'
				this.dialogVisibles = true
			},
			update() {
				if (this.RowData) {
					this.GetGradeStateInfo()

				} else {
					this.$message.warning('请选择您要操作的数据！')
				}
			},
			del() {
				if (this.selectIds.length) {
					this.Dialog.title = '确定要删除吗？'
					this.Dialog.src = require('@/assets/icon/icon-del2.png')
					this.dialogVisiblesMessage = true
				} else {
					this.$message.warning('请勾选操作的数据！')
				}
			},
			onRowClick(row) {
				this.RowData = row
			},
			handleCurrentChange(pageIndex) {
				this.pageIndex = pageIndex
				this.GetGradeStateList()
			},
			handleSizeChange(pageSize) {
				this.pageSize = pageSize
				this.GetGradeStateList()
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				if (this.DialogFrom.title == '新增') {
					this.AddGradeState()
				} else if (this.DialogFrom.title == '修改') {
					this.EditGradeState()
				}
			},
			cancelMessage() {
				this.dialogVisiblesMessage = false
			},
			dialogOKMessage() {
				if (this.Dialog.title == '确定要删除吗？') {
					this.DeleteGradeState()
				}
			}
		},
		computed: {},
		watch: {
			$route: {
				handler(to, from) {
					let data = JSON.parse(localStorage.getItem("MenusData"))
					data.Menus.forEach((item, index) => {
						if (item.NodeID == 9) {
							item.Nodes.forEach((items, indexs) => {
								if (items.NodeID == to.query.NodeID) {
									items.Nodes.forEach((itemes, indexes) => {
										if (itemes.NodeID == to.query.MenuID) {
											this.qus = itemes.Nodes
										}
									})
								}
							})
						}
					});
					if (this.qus) {
						this.qus.map((item, index) => {
							if (item.NodeName == 'add') {
								this.qx.add = true
							} else if (item.NodeName == 'edit') {
								this.qx.update = true
							} else if (item.NodeName == 'delete') {
								this.qx.del = true
							} else if (item.NodeName == 'stopif') {
								this.qx.del = true
							} else if (item.NodeName == 'assignment') {
								this.qx.assignment = true
							} else if (item.NodeName == 'enabled') {
								this.qx.enabled = true
							} else if (item.NodeName == 'skip') {
								this.qx.skip = true
							} else if (item.NodeName == 'reset') {
								this.qx.reset = true
							} else if (item.NodeName == 'setting') {
								this.qx.setting = true
							} else if (item.NodeName == 'submit') {
								this.qx.submit = true
							} else if (item.NodeName == 'approval') {
								this.qx.approval = true
							}
						})
					}
				},
				deep: true,
				immediate: true
			},
			dialogVisibles: {
				handler(dialogVisiblesNew, dialogVisiblesOld) {
					if (!dialogVisiblesNew) {
						this.$refs.DialogFromref.forEach((item, indedx) => {
							item.modelvalue = ''
						})
						this.DialogFrom.title = '加载中...'

					}

				}
			}
		},
	}
</script>
<style scoped lang='less'>
</style>